// Opening one exact call from the shell (feature contract 2.3 for the tape,
// 3.2 for the search suggestions): the id travels in the URL hash as "call",
// and Live Calls reads it.
//
// Two paths, because the hash means two different things here. On another
// destination the hash belongs to that destination, so nothing of it is
// carried: the caller hands `callHash(id)` to navigate and Live Calls opens
// with that and nothing else. Already on Live Calls there is no navigation at
// all, so the hash is written in place, keeping the layout key beside it.
//
// Assigning window.location.hash a value it already holds fires no hashchange
// event, so a second click on the item the URL already names would be silent.
// The event is raised directly in that case, which is the only way the
// destination hears a click that changes nothing about the URL.
import { writeHashParam } from '../ui/Tabs';

export const CALL_PARAM = 'call';

/** The hash a different destination should open Live Calls with. */
export function callHash(id: string): string {
  return `#${new URLSearchParams([[CALL_PARAM, id]]).toString()}`;
}

/** Writes "call" into the hash already on screen. Live Calls only. */
export function writeCallHash(id: string): void {
  if (typeof window === 'undefined') return;
  const next = writeHashParam(window.location.hash, CALL_PARAM, id);
  if (next === window.location.hash) {
    window.dispatchEvent(new Event('hashchange'));
    return;
  }
  window.location.hash = next;
}
